module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-five2.ee1d2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-five2.png
// module id = RoKO
// module chunks = 0